import React from 'react';
import { Box, Typography, Link, IconButton, Divider, Container } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

interface LocationInfoProps {
  title: string;
  address: string;
  phone: string;
  email: string;
}

const LocationInfo: React.FC<LocationInfoProps> = ({ title, address, phone, email }) => (
  <Box sx={{ flex: 1, textAlign: 'center' }}>
    <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
      {title}
    </Typography>
    <Typography variant="body2">{address}</Typography>
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, mt: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <PhoneIcon fontSize="small" />
        <Link href={`tel:${phone.replace(/[^0-9]/g, '')}`} color="inherit" underline="none">
          {phone}
        </Link>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <EmailIcon fontSize="small" />
        <Link href={`mailto:${email}`} color="inherit" underline="none">
          {email}
        </Link>
      </Box>
    </Box>
  </Box>
);

const SocialLinks: React.FC = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
    <IconButton
      href="https://www.facebook.com/people/5-Star-Laundromat/61573570883192/"
      sx={{ color: 'inherit' }}
      target="_blank"
    >
      <FacebookIcon />
    </IconButton>
    <IconButton
      href="https://www.instagram.com/5starlaundromats/"
      sx={{ color: 'inherit' }}
      target="_blank"
    >
      <InstagramIcon />
    </IconButton>
  </Box>
);

const Footer: React.FC = () => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        pt: 6,
        pb: 4,
        textAlign: 'center',
        bottom: 0,
        borderTopLeftRadius: '50% 10px',
        borderTopRightRadius: '50% 10px',
        transition: 'background-color 0.3s ease-in-out',
        mt: 4,
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            gap: 3,
          }}
        >
          <LocationInfo
            title="Winston-Salem Location"
            address="664 E Monmouth St, Winston-Salem, NC 27107"
            phone="(336) 624-5244"
            email="5starlaundromatnc@gmail.com"
          />
        </Box>
      </Container>

      <Divider
        sx={{
          my: 3,
          width: '80%',
          mx: 'auto',
          backgroundColor:
            theme.palette.background.paper,
        }}
      />

      <SocialLinks />

      <Typography variant="body2" sx={{ mt: 3 }}>
        © {currentYear} 5 Star Laundromat. All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
